import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PvRecruitmentService} from '../../pv-recruitment.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'pv-recruitement-formation-step',
    templateUrl: './recruitement-formation-step.component.html',
    styleUrls: ['./recruitement-formation-step.component.scss'],
    standalone: false
})
export class RecruitementFormationStepComponent implements OnInit {
  @Input() candidateUser: any;
  @Input() candidate: any;

  @Output() candidateUpdated = new EventEmitter();
  @Output() sessionSetError = new EventEmitter();

  constructor(private fb: UntypedFormBuilder,
              private recruitementService: PvRecruitmentService) { }

  public form: UntypedFormGroup;
  public sessions = [];
  public isSubmitting = false;

  ngOnInit(): void {
    this.form = this.fb.group({
      session: ['', Validators.required]
    });

    if (['missing', 'invalid'].includes(this.candidate.trainingStatus)) {
      this.loadSessions();
    }
  }

  private loadSessions() {
    this.recruitementService.getUpcomingWebinarSessions().then(sessions => {
      this.sessions = sessions;
    });
  }

  submit() {
    this.isSubmitting = true;
    const formValue = this.form.getRawValue();
    this.recruitementService.setWebinarSession(formValue).then(candidate => {
      this.candidateUpdated.emit(candidate);
    }).catch(() => {
      this.sessionSetError.emit();
      this.loadSessions();
    }).finally(() => {
      this.isSubmitting = false;
    });
  }

}
